import { render, staticRenderFns } from "./tw_noData.vue?vue&type=template&id=681fa57a&scoped=true&"
import script from "./tw_noData.vue?vue&type=script&lang=js&"
export * from "./tw_noData.vue?vue&type=script&lang=js&"
import style0 from "./tw_noData.vue?vue&type=style&index=0&id=681fa57a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681fa57a",
  null
  
)

export default component.exports